import { useModalPromise } from '@cp/shared/modal';
import { CARD_BINDING_MODAL } from '../lib';

export const useAddPaymentCard = () => {
  const cardBindingModal = useModalPromise(CARD_BINDING_MODAL);
  return [cardBindingModal] as const;
};
